import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { LOGO_URL } from "@/data/brand";

export default function Claim() {
  const [email, setEmail] = useState("");
  const [preview, setPreview] = useState(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email || !email.includes("@")) { setPreview(null); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/claim/preview?email=${encodeURIComponent(email)}`);
        setPreview(data);
      } catch { setPreview(null); }
    }, 400);
    return () => clearTimeout(t);
  }, [email]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/claim", { email });
      setSent(true);
      toast.success("Controlla la tua casella email");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 md:px-8 py-16" data-testid="claim-page">
      <Link to="/"><img src={LOGO_URL} alt="HostMarket" className="h-10 w-auto mb-10" /></Link>
      <div className="text-xs uppercase tracking-[0.3em] text-[#E619A8] mb-2">· Rivendica annuncio</div>
      <h1 className="font-heading font-black text-4xl sm:text-5xl leading-tight mb-4">Il tuo annuncio è <span className="text-[#FFBE00]">già online</span>.</h1>
      <p className="text-zinc-400 leading-relaxed mb-10 max-w-xl">Abbiamo migrato tutti gli annunci dal vecchio HostMarket. Inserisci la tua email: se corrisponde a uno o più annunci, ti mandiamo un link per rivendicarli e impostare la password in 30 secondi.</p>

      {sent ? (
        <div className="hm-card p-8" data-testid="claim-sent">
          <i className="fas fa-envelope-circle-check text-4xl text-[#22C55E] mb-4"></i>
          <h2 className="font-heading font-bold text-2xl mb-2">Email inviata</h2>
          <p className="text-zinc-400 text-sm">Se l'email corrisponde a un annuncio, hai ricevuto un link per rivendicarlo. Il link è valido per 7 giorni.</p>
          <Link to="/" className="inline-block mt-6 px-5 py-2 rounded-md border border-zinc-700 text-xs uppercase tracking-wider">Torna alla home</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="hm-card p-6 space-y-4" data-testid="claim-form">
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-500 mb-2 block">Email associata al tuo annuncio</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="la-tua-email@esempio.it" className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-4 py-3 text-sm focus:border-[#E619A8] focus:ring-1 focus:ring-[#E619A8] outline-none" data-testid="claim-email" />
          </div>
          {preview && preview.count > 0 && (
            <div className="border-l-2 border-[#22C55E] pl-4 py-2 bg-[#22C55E]/5" data-testid="claim-preview">
              <div className="text-xs uppercase tracking-wider text-[#22C55E]">✓ Trovati</div>
              <div className="text-sm text-white font-bold"><span className="text-[#FFBE00]">{preview.count}</span> annunc{preview.count === 1 ? 'io' : 'i'} {preview.name && `di ${preview.name}`}</div>
            </div>
          )}
          {preview && preview.count === 0 && email.length > 5 && (
            <div className="border-l-2 border-zinc-700 pl-4 py-2 text-xs text-zinc-500">Nessun annuncio trovato con questa email. Puoi comunque <Link to="/registrati" className="text-[#FFBE00] hover:underline">registrarti</Link> come nuovo utente.</div>
          )}
          <button type="submit" disabled={loading} className="w-full py-3 rounded-md bg-[#E619A8] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#FFBE00] hover:text-black transition-all disabled:opacity-50" data-testid="claim-submit">
            {loading ? "Invio…" : "Invia link di rivendicazione"}
          </button>
        </form>
      )}
    </div>
  );
}
